import type { IconName } from '@/components/Icon';

export interface NavPage {
  to: string;
  label: string;
  icon: IconName;
  group: 'Workspace' | 'Administration' | 'Help';
  adminOnly?: boolean;
  /** Match only this exact path (Home), not everything under it. */
  end?: boolean;
  /** Offered in Ctrl+K only — a shortcut into a page, not a sidebar entry of its own. */
  paletteOnly?: boolean;
}

/** Every page in the portal, in sidebar order. Drives both the sidebar and the Ctrl+K palette. */
export const navPages: NavPage[] = [
  { to: '/', label: 'Home', icon: 'home', group: 'Workspace', end: true },
  { to: '/playground', label: 'Playground', icon: 'play', group: 'Workspace' },
  { to: '/playground?mode=decisions', label: 'Playground: Decisions', icon: 'play', group: 'Workspace', paletteOnly: true },
  { to: '/templates', label: 'Skills', icon: 'skills', group: 'Workspace' },
  { to: '/file-tasks', label: 'File tasks', icon: 'file', group: 'Workspace' },
  { to: '/usage', label: 'My usage', icon: 'usage', group: 'Workspace' },
  { to: '/admin/approvals', label: 'Approvals', icon: 'approvals', group: 'Administration', adminOnly: true },
  { to: '/admin/callers', label: 'Callers', icon: 'callers', group: 'Administration', adminOnly: true },
  { to: '/admin/models', label: 'Models', icon: 'models', group: 'Administration', adminOnly: true },
  { to: '/admin/models?add=1', label: 'Add models', icon: 'models', group: 'Administration', adminOnly: true, paletteOnly: true },
  { to: '/admin/suppliers', label: 'Suppliers', icon: 'suppliers', group: 'Administration', adminOnly: true },
  { to: '/admin/mcp-servers', label: 'MCP servers', icon: 'mcp', group: 'Administration', adminOnly: true },
  { to: '/admin/usage', label: 'Gateway usage', icon: 'gateway', group: 'Administration', adminOnly: true },
  { to: '/get-started', label: 'Get started guide', icon: 'help', group: 'Help' },
  { to: '/get-started#step-7', label: 'API reference', icon: 'help', group: 'Help' }
];
